module.exports = __webpack_public_path__ + "static/media/TR.9d79414c.png";